var map = {
	"./1none.png": 2384,
	"./Baseball Jersey.png": 813,
	"./Basketball Jersey.png": 8609,
	"./Black Tee.png": 1168,
	"./Blue Golf Shirt.png": 4827,
	"./Blue Tropical Shirt.png": 4536,
	"./Bomber Jacket.png": 2058,
	"./Football Jersey.png": 2297,
	"./Gold Suitcoat.png": 3648,
	"./Green Golf Shirt.png": 9074,
	"./Green Tropical Shirt.png": 602,
	"./Grey Tee.png": 7553,
	"./Overalls.png": 9637,
	"./Puffer Jacket.png": 5528,
	"./Red Golf Shirt.png": 1026,
	"./Red Tropical Shirt.png": 2898,
	"./Suitcoat.png": 5566,
	"./Tank Top.png": 5671,
	"./White Tee.png": 460,
	"./Yellow Tee.png": 1189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7974;